import Vue from 'vue';
import App from './App.vue';
import router from './router';
import config from '@/config';
import ViewUI from 'view-design';
import store from './store';
import Meta from 'vue-meta'
import 'view-design/dist/styles/iview.css';
import VueClipboard from 'vue-clipboard2';

Vue.use(VueClipboard);
Vue.use(ViewUI);
Vue.use(Meta);
Vue.prototype.$bus = new Vue();

Vue.config.productionTip = false
Vue.prototype.config = config
new Vue({
    store,
    router,
    render: h => h(App),
}).$mount('#app')